
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { changeCarsImages } from './utils/functions.js';
import { initToggleCatalog } from './utils/functions.js';

Swiper.use([Navigation, Pagination, Autoplay]);
import 'swiper/css';
// import 'swiper/css/navigation';
// // import 'swiper/css/pagination';
window.Swiper = Swiper;




document.addEventListener('DOMContentLoaded', function() {
    const swiperContainer = document.querySelector('.swiper');
  
    if (swiperContainer) {
        // const swiper = new Swiper(swiperContainer, {
        //     // ваши параметры
        // });
    

        const swiper = new Swiper(swiperContainer, {
              modules: [Navigation, Pagination, Autoplay],
             loop: true,
            slidesPerView: 1,
            speed: 400,
            // autoplay: {
            //     delay: 5000,
            //   },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });




    } 


 changeCarsImages();
initToggleCatalog();

});


